import type { Brand } from "./lib/brand";
import type { PatientId } from "./patient.model";
import type { PractitionerId } from "./practitioner.model";
import type { RelatedPersonId } from "./related-person.model";
// ── Shared domain primitives ──

export interface CodeableConcept {
  coding?: Array<{ system?: string; code?: string; display?: string }>;
  text?: string;
}

/**
 * Resource needed to perform a catalog activity (extension-persisted on the
 * ActivityDefinition / PlanDefinition action). Either pinned by explicit
 * `reference` or selected at booking time by `category`.
 */
export interface ResourceRequirementInput {
  resourceType: "Location" | "Device";
  reference?: string;
  referenceDisplay?: string;
  category?: CodeableConcept;
  quantity: number;
}

/** Fixed clinic-capacity duration used by catalog and scheduling definitions. */
export interface SchedulingDuration {
  value: number;
  unit: "min" | "h";
}

export interface ActionParameterValue {
  name: string;
  label?: string;
  code: string;
  display: string;
}

export interface ContactPoint {
  system?: string;
  value?: string;
  use?: string;
}

export interface Period {
  start?: string;
  end?: string;
}

/** Who did something, when the kind of party varies. */
export type ResourcePointer =
  | { resourceType: "Patient"; id: PatientId }
  | { resourceType: "Practitioner"; id: PractitionerId }
  | { resourceType: "RelatedPerson"; id: RelatedPersonId };

/** Exact locator for references whose target is outside the modeled identity scheme. */
export type ReferencedResourceId = Brand<string, "ReferencedResourceId">;
export function asReferencedResourceId(value: string): ReferencedResourceId {
  return value as ReferencedResourceId;
}
